import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Heading, { HeadingSize } from '@standardsdigital/ui-components/Heading';
import Spinner from '@/components/global/Spinner/Spinner';
import NotFoundPage from '@/components/pages/NotFoundPage/NotFoundPage';
import {
  isCustomSubscriptionsEnabled,
  useLoadAdminSettingsQuery,
} from 'redux/services/settingsApi';
import Configuration from './Configuration/Configuration';
import ConfigurationSelector from './ConfigurationSelector/ConfigurationSelector';
import styles from './CustomSubscriptionConfigurationPage.module.css';

function CustomSubscriptionConfigurationPage() {
  const { t } = useTranslation();
  const { data: adminSettings, isLoading: isSettingsLoading } =
    useLoadAdminSettingsQuery();
  const [selectedConfigurationId, setSelectedConfigurationId] = useState('');

  if (isSettingsLoading) {
    return <Spinner position="centerAbsolute" size="large" />;
  }

  const hasPageAccess = isCustomSubscriptionsEnabled(adminSettings);
  if (!hasPageAccess) {
    return <NotFoundPage />;
  }

  return (
    <section className={styles.pageWrapper}>
      <Heading size={HeadingSize.Lg} level={1}>
        {t('headings.CustomSubscriptionConfiguration')}
      </Heading>
      <div className={styles.wrapper}>
        <ConfigurationSelector
          selectedConfigurationId={selectedConfigurationId}
          onSelectConfiguration={setSelectedConfigurationId}
        />
        <Configuration
          key={selectedConfigurationId}
          selectedConfigurationId={selectedConfigurationId}
          onSelectConfiguration={setSelectedConfigurationId}
        />
      </div>
    </section>
  );
}

export default CustomSubscriptionConfigurationPage;
